import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
//assets
import { useTranslation, withTranslation } from "react-i18next";

// const {t} = useTranslation('uauc');
import {
  RoundDelete,
  RoundEdit,
  TeamAdd,
  PolicyIcon,
  DdIcon,
  ElearnIcon,
  ElearnIconOrange,
  DdIconOrange,
  PolicyIconOrange,
} from "assets/Iconsv2/Iconsv2";
import ApproveRejectModal from "app/views/UaUc/PreReview/ARModal";
import ApproveRejectModal2 from "app/views/UaUc/PostReview/ARModal";

const DetailTimelineSection = ({
  data = [],
  state,
  url,
  functionContent,
  variableData,
  reportingScreen,
}) => {
  const { t } = useTranslation(["uauc", "util"]);
  const reportData = state.reportDetail;
  const { isApproveEnabled, isReportedUserEnabled } = variableData ?? {};
  const [showModalImage, setShowModalImage] = useState(false);
  const [showModalVideo, setShowModalVideo] = useState(false);
  const [showModalPdf, setShowModalPdf] = useState(false);
  const handleShowImage = () => {
    setShowModalImage(true);
  };
  const handleCloseImage = () => setShowModalImage(false);
  const handleShowVideo = () => {
    setShowModalVideo(true);
  };
  const handleCloseVideo = () => setShowModalVideo(false);
  const handleShowPdf = () => {
    setShowModalPdf(true);
  };
  const handleClosePdf = () => setShowModalPdf(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [approveData, setApproveData] = useState(null);

  return (
    <div className="row  clide-v2-colume_title ">
      <div className="mb-4 clide-v2-fs-3 fw-bold">{t("uaUCDt")}</div>
      <div className="row my-4 align-items-center">
        <div className="col-12 col-lg-3 col-md-3 px-0">
          <Link
            to={{
              ...url,
              ...(reportingScreen === "open" && {
                state: {
                  fromTab: "open",
                },
              }),
              ...(reportingScreen === "postReview" && {
                state: {
                  fromTab: "postReview",
                },
              }),
              ...(reportingScreen === "preReview" && {
                state: {
                  fromTab: "preReview",
                },
              }),
            }}
          >
            <Button
              className="border clide-v2-primary clide-v2-white-color"
              variant=""
            >
              <i className="fa fa-angle-left" aria-hidden="true"></i>
            </Button>
          </Link>
        </div>
        <div className="col-12 col-lg-4 col-md-4 ">
          <div>
            <span className="common-black-1 font-weight-500">
              {" "}
              {state.soiId ?? ""}{" "}
              <span
                style={{
                  borderLeft: "3px Solid Orange",
                  padding: "0 5px 0 5px",
                }}
              >
                {" "}
                {reportData.act_type} - {reportData.activity}{" "}
              </span>
              <span
                style={{
                  borderLeft: "3px Solid Orange",
                  padding: "0 5px 0 5px",
                }}
              >
                {reportData.reportedmonth_name}
              </span>
            </span>
          </div>
        </div>
        <div className="col-12 col-lg-5 col-md-5 d-flex justify-content-end px-0">
          <div className="d-flex align-items-center">
            <>
              {state?.activity_img ? (
                <div>
                  <button
                    className="clide-v2-icon-btn mr-2"
                    title={t("dd")}
                    onClick={handleShowImage}
                  >
                    <DdIconOrange />
                  </button>
                  <Modal
                    show={showModalImage}
                    onHide={handleCloseImage}
                    className="reportPopup "
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t("doDonts")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <img src={state.activity_img} alt=""></img>
                    </Modal.Body>
                  </Modal>
                </div>
              ) : null}

              {state?.activity_video ? (
                <div>
                  <button
                    className="clide-v2-icon-btn mr-2"
                    title={t("eLearn")}
                    onClick={handleShowVideo}
                  >
                    <ElearnIconOrange />
                  </button>
                  <Modal
                    show={showModalVideo}
                    onHide={handleCloseVideo}
                    className="reportPopup "
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t("eLearn")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <video
                        controls
                        width="100%"
                        style={{ borderRadius: "8px" }}
                        src={state.activity_video}
                      >
                        {" "}
                      </video>
                    </Modal.Body>
                  </Modal>
                </div>
              ) : null}

              {state?.activity_pdf ? (
                <div>
                  <button
                    className="clide-v2-icon-btn mr-2"
                    title={t("policy")}
                    onClick={handleShowPdf}
                  >
                    <PolicyIconOrange />
                  </button>
                  <Modal
                    show={showModalPdf}
                    onHide={handleClosePdf}
                    className="reportPopup "
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t("policy")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <iframe
                        src={`${state.activity_pdf}#toolbar=0`}
                        type="application/pdf"
                        width="100%"
                        height="500px"
                        title={t("pdfViewer")}
                        style={{ borderRadius: "8px" }}
                      />
                    </Modal.Body>
                  </Modal>
                </div>
              ) : null}

              {reportData.edit_flag == 1 && (
                <Link
                  to={`/edit-reporting-detail/${reportData.id}/${reportData.service_id}/${reportData.project_id}/edit`}
                >
                  <button className="clide-v2-icon-btn mr-2" title={t("edit")}>
                    <RoundEdit />
                  </button>
                </Link>
              )}

              {reportData.delete_status == 1 &&
              reportingScreen !== "archived" ? (
                <div>
                  <button
                    className="clide-v2-icon-btn mr-2"
                    title={t("delete")}
                    onClick={functionContent.showModal}
                  >
                    <RoundDelete />
                  </button>
                </div>
              ) : null}
            </>

            <div className="d-flex align-items-center gap-2">
              {(isApproveEnabled || isReportedUserEnabled) &&
              (state.resolveFlag == "open" || reportingScreen == "onHold") ? (
                <button
                  className="clide-v2-icon-btn mr-2"
                  title={t("addTeam")}
                  onClick={functionContent.openInviteUser}
                >
                  <TeamAdd />
                </button>
              ) : null}
              {reportingScreen !== "preReview" &&
                reportData.subStatus !== "pending" &&
                (state.resolveFlag === "resolve" ? (
                  reportingScreen === "postReview" &&
                  reportData.closing_tab_display === 1 ? (
                    <button
                      className="border btn clide-v2-active px-2 py-1"
                      title={t("resolve")}
                      onClick={functionContent.openResolve}
                    >
                      {t("resolve")}
                    </button>
                  ) : (
                    <span className="common-black-1 font-weight-500">
                      {t("resolved")}
                    </span>
                  )
                ) : (
                  reportData.closing_tab_display === 1 && (
                    <button
                      className="border btn clide-v2-active px-2 py-1"
                      title={t("resolve")}
                      onClick={functionContent.openResolve}
                    >
                      {t("resolve")}
                    </button>
                  )
                ))}

              {(reportingScreen === "preReview" ||
                reportingScreen === "postReview") && (
                <>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <div
                      className="clide-v2-primary-color mr-2"
                      style={{
                        border: "1px solid orange",
                        borderRadius: "15px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        padding: "5px 10px",
                      }}
                    >
                      <div>
                        {reportData.subStatus === "rejected" ? (
                          <span className="fw-bold">
                            Rejected
                            {(reportingScreen === "postReview"
                              ? reportData.preResolveRejectedCount
                              : reportData.preOpenRejectedCount) > 0 &&
                              ` (${
                                reportingScreen === "postReview"
                                  ? reportData.preResolveRejectedCount
                                  : reportData.preOpenRejectedCount
                              })`}
                          </span>
                        ) : reportingScreen === "postReview" ? (
                          <>
                            {reportData.preResolveRejectedCount > 0
                              ? `Resubmitted (${reportData.preResolveRejectedCount})`
                              : "Submitted"}{" "}
                            for Review
                          </>
                        ) : (
                          <>
                            {reportData.preOpenRejectedCount > 0
                              ? `Resubmitted (${reportData.preOpenRejectedCount})`
                              : "Submitted"}{" "}
                            for Review
                          </>
                        )}
                      </div>
                    </div>
                    {/* Approve Button */}
                    {reportData.subStatus !== "rejected" &&
                      reportData.canApproveReject === true && (
                        <>
                          <button
                            style={{
                              padding: "3px 10px",
                              border: "1px solid green",
                              background: "#e6f9e6", // faint green background
                              color: "green",
                              borderRadius: "4px",
                              fontSize: "11px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setShowApproveModal(true);
                              setModalStatus("Approve");
                              setApproveData({
                                uaucId: reportData.id,
                                dueDate:
                                  reportData.due_date || reportData.target_date,
                                reportingScreen: reportingScreen,
                                isRiskBaseDueDate: reportData.isRiskBaseDueDate,
                              });
                            }}
                          >
                            Approve
                          </button>

                          {/* Reject Button */}
                          <button
                            style={{
                              padding: "3px 10px",
                              border: "1px solid #800000", // dark maroon border
                              background: "#fceaea", // light maroon background
                              color: "#a52a2a", // medium maroon text
                              borderRadius: "4px",
                              fontSize: "11px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setShowApproveModal(true);
                              setModalStatus("Reject");
                              setApproveData({
                                uaucId: reportData.id,
                                dueDate:
                                  reportData.due_date || reportData.target_date,
                                reportingScreen: reportingScreen,
                              });
                            }}
                          >
                            Reject
                          </button>
                        </>
                      )}
                  </div>
                </>
              )}
              {(reportingScreen === "resolve" ||
                reportingScreen === "open") && (
                <div style={{ display: "flex", gap: "8px" }}>
                  {/* Outer container with border */}
                  <div
                  // style={{
                  //   border: "1px solid #1e7b1e",
                  //   borderRadius: "8px",
                  //   padding: "8px 12px",
                  //   backgroundColor: "#f9fff9",
                  // }}
                  >
                    {/* Buttons container */}
                    <div style={{ display: "flex", gap: "10px" }}>
                      {reportData.preReview && (
                        <button
                          style={{
                            backgroundColor: "#e8f8e8",
                            color: "#1e7b1e",
                            border: "1px solid #1e7b1e",
                            borderRadius: "10px",
                            padding: "4px 10px",
                            fontWeight: 600,
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            cursor: "default",
                          }}
                        >
                          ✓ Pre - Approved (
                          {(reportData.preResolveRejectedCount || 0) + 1})
                        </button>
                      )}

                      {reportData.postReview &&
                        reportingScreen === "resolve" && (
                          <button
                            style={{
                              backgroundColor: "#e8f8e8",
                              color: "#1e7b1e",
                              border: "1px solid #1e7b1e",
                              borderRadius: "10px",
                              padding: "4px 10px",
                              fontWeight: 600,
                              fontSize: "13px",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              cursor: "default",
                            }}
                          >
                            ✓ Post - Approved (
                            {(reportData.postResolveRejectedCount || 0) + 1})
                          </button>
                        )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="pe-3 clide-v2-p-0">
        <div className="clide-v2-card-box-1 p-3 ">
          <div className="text-center clide-v2-primary-color py-4">
            {t("timeline")}
          </div>
          <div className="overflow-x overflow-auto">
            <div
              className="line_box stav_projektu"
              style={{ margin: "40px 0 40px 0" }}
            >
              {data?.map((el) => {
                return (
                  <div className="text_circle done ">
                    <a href="javascript:void(0)" className="tvar">
                      <span />
                    </a>
                    <div className="circle clide-v2-white-box h-75">
                      {el?.title}
                      <hr />
                      {el?.cardTitle}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <ApproveRejectModal
        show={showApproveModal}
        status={modalStatus}
        approveData={approveData}
        handleClose={() => setShowApproveModal(false)}
        reportingScreen={reportingScreen}
      />
      <ApproveRejectModal2
        show={showRejectModal}
        status={modalStatus}
        approveData={approveData}
        handleClose={() => setShowRejectModal(false)}
        reportingScreen={reportingScreen}
      />
    </div>
  );
};

export default React.memo(DetailTimelineSection);
